import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://pagos.academiaholisticaargentina.com/cart/48444837920985:1';
const CHECKOUT_PRO = 'https://pagos.academiaholisticaargentina.com/cart/48444840083673:1';
function FeatureItem({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex items-start gap-2 text-left" data-id="element-254">
      <div className="bg-[#eab308]/20 p-0.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-255">
        <CheckIcon className="w-3 h-3 text-[#eab308]" strokeWidth={3} data-id="element-256" />
      </div>
      <span className="text-gray-300 text-xs sm:text-sm leading-snug" data-id="element-257">
        {children}
      </span>
    </div>;
}
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 relative overflow-hidden border-t border-white/5" data-id="element-258">
      <div className="container mx-auto max-w-5xl" data-id="element-259">
        <div ref={ref1} className={`reveal text-center mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-260">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-261">
            Elegí tu camino de formación
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-262">
            Dos opciones diseñadas para acompañarte desde tu primera práctica
            hasta tu desarrollo profesional.
          </p>
        </div>

        <div ref={ref2} id="pricing-offer" style={{
        scrollMarginTop: '80px'
      }} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-stretch ${vis2 ? 'is-visible' : ''}`} data-id="element-263">
          {/* Pro Card — FIRST (left) */}
          <div className="relative bg-gradient-to-b from-[#111111] to-[#0a0a0a] rounded-xl p-4 sm:p-6 border-2 border-[#eab308]/50 shadow-[0_0_50px_rgba(234,179,8,0.15)] flex flex-col z-10" data-id="element-264">
            <div className="inline-flex self-center bg-gradient-to-r from-[#eab308] to-[#d4a017] text-[#0f0f1a] text-[10px] sm:text-xs font-bold px-4 py-1.5 rounded-full shadow-lg mb-1 whitespace-nowrap" data-id="element-265">
              ⭐ RECOMENDADO
            </div>
            <div className="inline-flex self-center bg-white/10 text-white text-[10px] sm:text-xs font-bold px-3 py-1 rounded-full mb-4 whitespace-nowrap" data-id="element-266">
              👑 MÁS COMPLETO
            </div>

            <div className="relative text-center mb-5" data-id="element-267">
              <span className="text-[#eab308] text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase mb-2 block" data-id="element-268">
                KIT PRO
              </span>
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-white mb-3" data-id="element-269">
                Kit Reiki Pro
              </h3>
              <p className="text-3xl sm:text-4xl font-extrabold text-[#eab308] leading-none" data-id="element-270">
                $29.990
              </p>
              <p className="text-gray-500 text-xs line-through mt-1.5" data-id="element-271">
                $84.930
              </p>
              <p className="text-[#eab308] font-bold text-[10px] sm:text-xs mt-1.5" data-id="element-272">
                💳 Hasta 3 cuotas sin interés
              </p>
            </div>

            <div className="space-y-2 mb-5 flex-grow" data-id="element-273">
              <p className="text-gray-400 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-2" data-id="element-274">
                Todo lo del Sistema Base +
              </p>

              <div className="bg-[#eab308]/10 border border-[#eab308]/20 rounded-lg p-3 space-y-2 mb-3" data-id="element-275">
                <p className="text-[#eab308] font-bold text-xs mb-1.5" data-id="element-276">
                  💎 Herramientas Profesionales
                </p>
                <FeatureItem data-id="element-277">
                  Certificado Oficial de Practitioner Profesional
                </FeatureItem>
                <FeatureItem data-id="element-278">
                  Pack de Documentación Profesional completo
                </FeatureItem>
                <FeatureItem data-id="element-279">
                  30 Plantillas de Redes Sociales editables en Canva
                </FeatureItem>
                <FeatureItem data-id="element-280">Guión de Primera Sesión</FeatureItem>
                <FeatureItem data-id="element-281">Protocolo de Programa de 4 Sesiones</FeatureItem>
                <FeatureItem data-id="element-282">
                  Masterclass — Cómo fijar tus precios sin subestimarte
                </FeatureItem>
              </div>
            </div>

            <a href={CHECKOUT_PRO} target="_blank" rel="noopener noreferrer" className="w-full block py-3 sm:py-4 rounded-xl text-[#0f0f1a] font-bold text-xs sm:text-sm tracking-wider sm:tracking-widest uppercase text-center transition-all shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-283">
              💎 QUIERO EL KIT PRO
            </a>
            <p className="text-center text-gray-400 text-[10px] sm:text-xs mt-2" data-id="element-284">
              Solo $10.000 más que el sistema base.
            </p>
          </div>

          {/* Base Card — SECOND (right) */}
          <div className="bg-[#111111] rounded-xl p-4 sm:p-6 border border-white/10 shadow-xl flex flex-col" data-id="element-285">
            <div className="text-center mb-5" data-id="element-286">
              <span className="text-gray-400 text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase mb-2 block" data-id="element-287">
                📦 MAESTRÍA
              </span>
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-white mb-3" data-id="element-288">
                Sistema Maestría Reiki
              </h3>
              <p className="text-3xl sm:text-4xl font-extrabold text-white leading-none" data-id="element-289">
                $19.990
              </p>
              <p className="text-gray-500 text-xs line-through mt-1.5" data-id="element-290">
                $47.940
              </p>
              <p className="text-gray-300 font-bold text-[10px] sm:text-xs mt-1.5" data-id="element-291">
                💳 Hasta 3 cuotas sin interés
              </p>
            </div>

            <div className="space-y-2 mb-5 flex-grow" data-id="element-292">
              <p className="text-gray-400 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-2" data-id="element-293">
                Todo lo que recibís hoy:
              </p>
              <FeatureItem data-id="element-294">TOMO I — El Despertar del Canal</FeatureItem>
              <FeatureItem data-id="element-295">TOMO II — Simbología y Distancia</FeatureItem>
              <FeatureItem data-id="element-296">TOMO III — La Maestría Espiritual</FeatureItem>
              <FeatureItem data-id="element-297">TOMO IV — El Manual del Iniciador</FeatureItem>
              <FeatureItem data-id="element-298">TOMO V — Reiki Business: Salida Laboral</FeatureItem>
              <FeatureItem data-id="element-299">TOMO VI — Protocolos de Emergencia</FeatureItem>
              <div className="pt-2" data-id="element-300">
                <p className="text-[#eab308] font-bold text-sm mb-2" data-id="element-301">
                  🎁 + 6 Bonos exclusivos
                </p>
                <FeatureItem data-id="element-302">Reiki en 7 Días</FeatureItem>
                <FeatureItem data-id="element-303">Mapa de Chakras Aplicado</FeatureItem>
                <FeatureItem data-id="element-304">Manual Anti-Dudas</FeatureItem>
                <FeatureItem data-id="element-305">Reiki para Ansiedad y Estrés</FeatureItem>
                <FeatureItem data-id="element-306">Reiki de Bolsillo</FeatureItem>
                <FeatureItem data-id="element-307">Diario de Práctica y Progreso 30 Días</FeatureItem>
              </div>
              <div className="pt-2 border-t border-white/10 mt-2" data-id="element-308">
                <FeatureItem data-id="element-309">Acceso inmediato y de por vida</FeatureItem>
                <FeatureItem data-id="element-310">Garantía de 7 días sin preguntas</FeatureItem>
              </div>
            </div>

            <a href={CHECKOUT_BASE} target="_blank" rel="noopener noreferrer" className="w-full block py-3 sm:py-4 rounded-xl text-white font-bold text-xs sm:text-sm tracking-wider sm:tracking-widest uppercase text-center transition-all hover:-translate-y-1 bg-white/10 hover:bg-white/15 border border-white/20 hover:border-white/30" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-311">
              📦 QUIERO LA MAESTRÍA
            </a>
          </div>
        </div>
      </div>
    </section>;
}